export default __webpack_public_path__ + "static/media/o1.568b662a.webp";